import React, { Component } from 'react';
import Page from '../pages/Page';
import ProfileContainer from '../containers/Autopilot';
import {injectIntl} from 'react-intl';

class Profile extends Component {
  getMetaData() {
    return {
      title: this.pageTitle(),
      meta: this.pageMeta(),
      link: this.pageLink()
    };
  }

  pageTitle = () => {
    return this.props.intl.formatMessage({id: 'autopilot.pageTitle'});
  };

  pageMeta = () => {
    return [
      { name: 'description', content: this.props.intl.formatMessage({id: 'autopilot.pageDescription'}) }
    ];
  };

  pageLink = () => {
    return [];
  };

  render() {
    return (
      <Page {...this.getMetaData()}>
        <ProfileContainer {...this.props} />
      </Page>
    );
  }
}

export default injectIntl(Profile);




// WEBPACK FOOTER //
// app/pages/Autopilot.jsx